module.exports = __webpack_public_path__ + "348d52bf9c64885071cc04efaffc5fde.png";